import React from 'react'
import { Link } from 'react-router-dom'
import { useCart } from '../state/CartContext'
import { useI18n } from '../state/I18nContext'
import BadgePills, { type Badge } from './BadgePills'
import AddToCartButton from './AddToCartButton'

export type Product = {
  id: string
  name: string
  price: number
  image: string
  badges?: Badge[]
  category: string
  description: string
}

const ProductCard: React.FC<{ product: Product }> = ({ product }) => {
  const { add } = useCart()
  const { locale, t } = useI18n()
  return (
    <div className="group rounded-xl border border-neutral-200 overflow-hidden bg-white shadow-sm hover:shadow-md transition">
      <Link to={`/${locale}/product/${product.id}`} className="block">
        <div className="aspect-square overflow-hidden">
          <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition" />
        </div>
        <div className="p-4">
          <div className="flex flex-col items-start justify-between">
            <BadgePills badges={product.badges} className="mb-2" />
            <h3 className="font-semibold text-lg">{product.name}</h3>
          </div>
            {/* <p className="text-sm text-neutral-600 mt-1">{product.category}</p> */}
          <p className="mt-3 font-bold text-amber-700">€ {product.price.toFixed(2)}</p>
        </div>
      </Link>
      <div className="px-4 pb-4">
        <AddToCartButton
          className="w-full rounded-lg bg-amber-600 text-white py-2.5 font-medium hover:bg-amber-700 transition"
          onAdd={() => add({ id: product.id, name: product.name, price: product.price, image: product.image })}
        >
          {t.product.addToCart}
        </AddToCartButton>
      </div>
    </div>
  )
}

export default ProductCard
